exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-checkbox[data-v-5876240c],[data-v-5876240c] .el-radio{white-space:normal!important}", ""]);

// exports
